import ROUTES from './routes.json'

export const legalRoutes = [
  ROUTES.SWEEPSTAKE_RULES,
  ROUTES.RESPONSIBLE_PLAY,
  ROUTES.PRIVACY,
  ROUTES.TERMS,
  ROUTES.LOCATION_VERIFICATION,
  ROUTES.LOCATION_RESTRICTED,
  ROUTES.LEGAL_SWEEPSTAKE_RULES,
  ROUTES.LEGAL_TERMS,
  ROUTES.LEGAL_PRIVACY,
  ROUTES.CONFIRM_EMAIL,
]
